import {
	CREATE_ARTICLES_PROPS_CHANGED,
	CREATE_ARTICLE_SET_ARTICLE_TO_EDIT,
	CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS,
	CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_SUCCESS,
	CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_FAILURE,
	CREATE_ARTICLES_SAVE_ARTICLE,
	CREATE_ARTICLES_SAVE_ARTICLE_SUCCESS,
	CREATE_ARTICLES_SAVE_ARTICLE_FAILURE,
	CREATE_ARTICLES_SUBMIT_ARTICLE,
	CREATE_ARTICLES_SUBMIT_ARTICLE_SUCCESS,
	CREATE_ARTICLES_SUBMIT_ARTICLE_FAILURE,
	CREATE_ARTICLES_APPROVE_ARTICLE_SUCCESS, CREATE_ARTICLES_APPROVE_ARTICLE, CREATE_ARTICLES_APPROVE_ARTICLE_FAILURE,
} from "./actions";
import {nowDateTimeToUs} from "../../../../utility/functions";
import {getItem, keys} from "../../../../localStorage";

export const requiredFieldsForArticleUpload = [
	"strapline",
	"title",
	"lead",
	"body",
	"author",
	"mainImage",
];

export const requiredFieldsForGalleryUpload = [
	"strapline",
	"title",
	"lead",
	"mainImage",
	"author",
	"images",
];

export const defaultArticleState = {
	strapline: "",
	title: "",
	lead: "",
	body: "",
	layout: null,
	mainImage: null,
	publishedDate: nowDateTimeToUs(),
	author: null,
	images: null,
};

export const initialState = {
	strapline: "",
	title: "",
	lead: "",
	body: "",
	layout: null,
	mainImage: null,
	publishedDate: nowDateTimeToUs(),
	publishDateString: null,
	author: null,
	images: null,
	articleToEdit: null,
	articleToEditUnsaved: null,
	hasUnsavedChanges: false,
	layouts: null,
	isSelectingMainImage: false,
	isSelectingImages: false,
	savingArticle: false,
	submitingArticle: false,
	approvingArticle: false,
	isBodyShowing: false,
	canShowUnsavedChangesModal: false,
	errors: null,
	hasAuthorRights: false,
	showHasAuthorRightsModal: false,
	showAddToPresentation: false,
	sections: null,
	section: null,
};

export const createNewArticlesReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS:
			return {
				...state,
			};
		case CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_SUCCESS:
			return {
				...state,
				layouts: action.layouts,
			};
		case CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_FAILURE:
			return {
				...state,
			};

		case CREATE_ARTICLES_SAVE_ARTICLE:
			return {
				...state,
				savingArticle: true,
			};
		case CREATE_ARTICLES_SAVE_ARTICLE_SUCCESS:
			return {
				...state,
				savingArticle: false,
				...defaultArticleState,
				hasUnsavedChanges: false,
			};
		case CREATE_ARTICLES_SAVE_ARTICLE_FAILURE:
			return {
				...state,
				savingArticle: false,
			};

		case CREATE_ARTICLES_SUBMIT_ARTICLE:
			return {
				...state,
				submitingArticle: true,
			};
		case CREATE_ARTICLES_SUBMIT_ARTICLE_SUCCESS:
			return {
				...state,
				submitingArticle: false,
				...defaultArticleState,
				showAddToPresentation: getItem(keys.role) === "1",
				hasUnsavedChanges: false,
			};
		case CREATE_ARTICLES_SUBMIT_ARTICLE_FAILURE:
			return {
				...state,
				submitingArticle: false
			};


		case CREATE_ARTICLES_APPROVE_ARTICLE:
			return {
				...state,
				approvingArticle: true
			};
		case CREATE_ARTICLES_APPROVE_ARTICLE_SUCCESS:
			return {
				...state,
				approvingArticle: false,
				...defaultArticleState,
				hasUnsavedChanges: false,
			};
		case CREATE_ARTICLES_APPROVE_ARTICLE_FAILURE:
			return {
				...state,
				approvingArticle: false
			};

		case CREATE_ARTICLE_SET_ARTICLE_TO_EDIT:
			return {
				...state,
				articleToEditUnsaved: state.articleToEdit && state.hasUnsavedChanges? action.articleToEdit : null,
				articleToEdit: state.articleToEdit && state.hasUnsavedChanges? state.articleToEdit : action.articleToEdit,
			};

		case CREATE_ARTICLES_PROPS_CHANGED:
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};